// src/hooks/useOrgName.js
// Fetches the org name once after auth is established and stores it in
// useAuthStore so any component can read it without re-fetching.
 
import { useEffect } from "react";
import { useAuthStore } from "../stores/useAuthStore";
import { fetchWithAuth } from "../api/fetchWithAuth";
 
export function useOrgName() {
  const orgId   = useAuthStore((s) => s.orgId);
  const orgName = useAuthStore((s) => s.orgName);
  const setOrgName = useAuthStore((s) => s.setOrgName);
 
  useEffect(() => {
    // Only fetch if we have an orgId and haven't already loaded the name
    if (!orgId || orgName) return;
 
    async function fetchOrgName() {
      try {
        const res = await fetchWithAuth("/api/v1/org");
        if (!res.ok) return;
        const data = await res.json();
        if (data.name) setOrgName(data.name);
      } catch (err) {
        console.warn("[useOrgName] fetch failed", err);
      }
    }
 
    fetchOrgName();
  }, [orgId, orgName, setOrgName]);
}
 